<template>
  <ElConfigProvider :locale="ptBR">
    <NuxtLoadingIndicator />

    <nav
      class="fixed top-0 z-10 w-full bg-white border-b border-gray-100 dark:bg-gray-900 dark:border-gray-950"
    >
      <div class="px-3 py-3 lg:px-5 lg:pl-3">
        <div class="flex items-center justify-between">
          <div class="flex items-center">
            <nuxt-link to="/" class="flex ml-2 mr-10">
              <span
                class="self-center primary text-xl font-semibold sm:text-2xl whitespace-nowrap"
              >
                <img src="/ooadmin.png" class="h-[45px]" />
              </span>
            </nuxt-link>
          </div>

          <UserMenu />
        </div>
      </div>
    </nav>

    <div class="bg-gray-100 dark:bg-gray-900 w-full">
      <div
        class="container mx-auto max-w-[1300px] mt-[70px] rounded-r-md bg-gray-100 dark:bg-gray-900 ooloja-template"
      >
        <slot />
      </div>
    </div>

    <button
      id="to-top-button"
      @click="goToTop()"
      title="Go To Top"
      class="hidden fixed z-50 bottom-14 right-5 lg:right-8 border-0 w-12 h-12 lg:w-14 lg:h-14 rounded-full drop-shadow-md bg-indigo-500 text-white"
    >
      <Icon name="solar:alt-arrow-up-outline" class="text-[30px]" />
    </button>

    <div class="relative bottom-0 w-full bg-gray-800/5">
      <div class="flex justify-end p-4">
        <div>
          Versão <span>{{ config.public.sistemaVersao }}</span>
        </div>
      </div>
    </div>
  </ElConfigProvider>
</template>

<script setup>
import ptBR from "element-plus/dist/locale/pt-br.mjs";

const config = useRuntimeConfig();

import { useUiStore } from "~/stores/ui.store";
const uiStore = useUiStore();

import { useUserStore } from "../stores/usuario_store";
const userStore = useUserStore();

const isAutenticated = ref(false);

isAutenticated.value = await userStore.isAuthenticated;

function goToTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}
</script>

<style></style>
